<button
    class="w-full flex items-center justify-center"
    [ngClass]="buttonClasses"
    [ngStyle]="buttonStyle"
    (click)="openJobDialog()"
    i18n>
    <span class="mat-icon" *ngIf="buttonConfig?.icon">{{ buttonConfig.icon }}</span>
    More Details
</button>
